import React from 'react';
import QRCode from 'qrcode.react';

export function QRCodeComponent({ value, size, bgColor, fgColor }) {
	console.log("qrcode2: "+value);
    return <QRCode
		value={value}
		size={size}
		bgColor={bgColor}
		fgColor={fgColor}
		renderAs="svg"
	/>;
};
